var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"text-center up",attrs:{"absolute":true,"value":_vm.loading}},[_c('lottie-animation',{ref:"anim",attrs:{"animationData":require('@/assets/animations/' + _vm.animation + '.json'),"loop":true,"autoPlay":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }